module.exports = __webpack_public_path__ + "img/kefu.7d237159.png";